import { render, staticRenderFns } from "./SkeletonRecoMobilesCard.vue?vue&type=template&id=02cd3d54"
import script from "./SkeletonRecoMobilesCard.vue?vue&type=script&lang=js"
export * from "./SkeletonRecoMobilesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports